import { render, staticRenderFns } from "./EditPlace.vue?vue&type=template&id=833af628&scoped=true&"
import script from "./EditPlace.vue?vue&type=script&lang=js&"
export * from "./EditPlace.vue?vue&type=script&lang=js&"
import style0 from "./EditPlace.vue?vue&type=style&index=0&id=833af628&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "833af628",
  null
  
)

export default component.exports